import { useRef, useState } from 'react'
import Customupload from '../../components/UploadFile'
import Style from './upload.module.scss'
import { HTTP } from '../../api/http'
import { RcFile } from 'antd/lib/upload'
import { message, Button } from 'antd'
import { download, generateRegExp } from '../../tools/util'
import { UploadOutlined } from '@ant-design/icons'
import CustomIcon from '../../components/IconUser'
import PreviewModal from '../../components/previewModal'
import { UPLOAD_FILES_NO_SAVE } from '../../api/orderManage'
import { EMPTY_ARRAY } from '@/global/config'
import { bytesInstance } from '@xhgj/xh-jsutils'

// 接受文件类型
const ACCEPT_FILE_TYPE = '.doc,.docx,.pdf,.xls,.xlsx,.txt'

export interface fileFile {
  url: string
  baseUrl: string
  name: string
}

export type MaterialFilesType =
  | 'productLiteratures' // 产品资料
  | 'reports' // 检测报告
  | 'certificateOfQualitys' // 质量证明
  | 'inquiry' // 询价单

interface Props {
  // 原始受控数据源，用于非 Form 使用
  dataSource?: fileFile[]
  // antd Form 触发器：trigger="onChange"
  onChange?: (e: fileFile[]) => void
  productCode?: string
  tempCode?: string
  maxCount?: number // 可上传的数量
  type?: MaterialFilesType
  // 透传到上传控件的配置
  accept?: string
  uploadBtn?: React.ReactNode
  uploadBtnSuffix?: React.ReactNode
  visibleFile?: boolean
  multiple?: boolean
  // 简单按钮文案（可选），与 uploadBtn 二选一
  textBtn?: string
  maxSize?: number
  maxSizeErrorText?: string
}
// 上传文件
const Uploadfiles = (props: Props) => {
  const {
    dataSource = EMPTY_ARRAY,
    onChange,
    tempCode,
    maxCount = 10,
    maxSize = 1024 * 1024 * 10,
    maxSizeErrorText,
    type,
    accept = ACCEPT_FILE_TYPE,
    uploadBtn,
    visibleFile = false,
    multiple = true,
    textBtn,
    uploadBtnSuffix,
  } = props

  const [previewFileUrl, setPreviewFileUrl] = useState<string>('')
  const [isPreviewModalVisible, setIsPreviewModalVisible] =
    useState<boolean>(false)

  const cancelPreviewModal = () => {
    setIsPreviewModalVisible(false)
  }

  const showPreviewModal = (item: fileFile) => {
    setPreviewFileUrl(item.baseUrl + item.url)
    setIsPreviewModalVisible(true)
  }

  // 上传文件
  async function uploadfile(file: RcFile[]) {
    // if (!type || !tempCode) {
    //   message.error('上传失败：缺少必要参数 type 或 tempCode')
    //   return
    // }
    const resData: any = await UPLOAD_FILES_NO_SAVE(
      { type, code: tempCode },
      file,
    )
    if (resData.code === 0) {
      const data = resData.data
      message.success('上传成功')
      const arr = dataSource.concat(data)
      onChange?.(arr)
    }
  }

  // 删除文件
  function onClickDel(index: string) {
    const arr = dataSource.filter((item) => item.url !== index)
    onChange?.(arr)
  }

  // 下载文件
  function onClickDown(index: number) {
    // 获取下载路径
    const file = dataSource[index]
    const url = `${file.baseUrl ? file.baseUrl : HTTP}${file.url}`
    download(url)
  }

  const uploadFlag = useRef<number>(0)

  // 上传之前处理文件
  function beforeUpload(file: RcFile, FileList: RcFile[]) {
    const reg = generateRegExp(accept)
    const index = file.name.search(reg)
    if (FileList.length + dataSource.length > maxCount) {
      message.error(`上传失败：文件数量超出限制（${maxCount}个）`)
      uploadFlag.current = 0
      return false
    }
    if (file.size > maxSize) {
      message.error(
        maxSizeErrorText ||
          `上传失败：请勿上传超过${bytesInstance.convert(maxSize)}的文件！`,
      )
      uploadFlag.current = 0
      return false
    } else if (index === -1) {
      // 限制上传文件格式
      message.error('上传失败：请上传正确的文件格式！')
      uploadFlag.current = 0
      return false
    }
    uploadFlag.current++
    if (uploadFlag.current === FileList.length) {
      uploadfile(FileList)
      uploadFlag.current = 0
    }
    return false
  }

  return (
    <div className={Style.filebox}>
      {dataSource.map((item, index) => (
        <div className={Style.fileitem} key={index}>
          <CustomIcon type="icon-wenjian1" style={{ fontSize: '20px' }} />
          <span
            onClick={() => showPreviewModal(item)}
            style={{ cursor: 'pointer' }}
          >
            {item.name}
          </span>
          <CustomIcon
            type="icon-shanchu1"
            onClick={() => onClickDel(item.url)}
            className={Style.delicon}
          />
          <Button
            size="small"
            type="link"
            style={{ fontSize: '12px' }}
            onClick={() => onClickDown(index)}
          >
            下载
          </Button>
        </div>
      ))}
      {dataSource.length < maxCount && (
        <Customupload
          accept={accept}
          uploadBtn={
            uploadBtn ?? (
              <>
                <Button
                  type="default"
                  size="small"
                  style={{ margin: '0 0 10px 0' }}
                >
                  <UploadOutlined /> {textBtn ?? '上传文件'}
                </Button>
                {uploadBtnSuffix}
              </>
            )
          }
          beforeUpload={beforeUpload}
          visibleFile={visibleFile}
          multiple={multiple}
        />
      )}
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      />
    </div>
  )
}

export default Uploadfiles
import { useRef, useState } from 'react'
import Customupload from '../../components/UploadFile'
import Style from './upload.module.scss'
import { HTTP } from '../../api/http'
import { RcFile } from 'antd/lib/upload'
import { message, Button } from 'antd'
import { download, generateRegExp } from '../../tools/util'
import { UploadOutlined } from '@ant-design/icons'
import CustomIcon from '../../components/IconUser'
import PreviewModal from '../../components/previewModal'
import { UPLOAD_FILES_NO_SAVE } from '../../api/orderManage'
import { EMPTY_ARRAY } from '@/global/config'
import { bytesInstance } from '@xhgj/xh-jsutils'

// 接受文件类型
const ACCEPT_FILE_TYPE = '.doc,.docx,.pdf,.xls,.xlsx,.txt'

export interface fileFile {
  url: string
  baseUrl: string
  name: string
}

export type MaterialFilesType =
  | 'productLiteratures' // 产品资料
  | 'reports' // 检测报告
  | 'certificateOfQualitys' // 质量证明
  | 'inquiry' // 询价单

interface Props {
  // 原始受控数据源，用于非 Form 使用
  dataSource?: fileFile[]
  // antd Form 触发器：trigger="onChange"
  onChange?: (e: fileFile[]) => void
  productCode?: string
  tempCode?: string
  maxCount?: number // 可上传的数量
  type?: MaterialFilesType
  // 透传到上传控件的配置
  accept?: string
  uploadBtn?: React.ReactNode
  uploadBtnSuffix?: React.ReactNode
  visibleFile?: boolean
  multiple?: boolean
  // 简单按钮文案（可选），与 uploadBtn 二选一
  textBtn?: string
  maxSize?: number
  maxSizeErrorText?: string
}
// 上传文件
const Uploadfiles = (props: Props) => {
  const {
    dataSource = EMPTY_ARRAY,
    onChange,
    tempCode,
    maxCount = 10,
    maxSize = 1024 * 1024 * 10,
    maxSizeErrorText,
    type,
    accept = ACCEPT_FILE_TYPE,
    uploadBtn,
    visibleFile = false,
    multiple = true,
    textBtn,
    uploadBtnSuffix,
  } = props

  const [previewFileUrl, setPreviewFileUrl] = useState<string>('')
  const [isPreviewModalVisible, setIsPreviewModalVisible] =
    useState<boolean>(false)

  const cancelPreviewModal = () => {
    setIsPreviewModalVisible(false)
  }

  const showPreviewModal = (item: fileFile) => {
    setPreviewFileUrl(item.baseUrl + item.url)
    setIsPreviewModalVisible(true)
  }

  // 上传文件
  async function uploadfile(file: RcFile[]) {
    // if (!type || !tempCode) {
    //   message.error('上传失败：缺少必要参数 type 或 tempCode')
    //   return
    // }
    const resData: any = await UPLOAD_FILES_NO_SAVE(
      { type, code: tempCode },
      file,
    )
    if (resData.code === 0) {
      const data = resData.data
      message.success('上传成功')
      const arr = dataSource.concat(data)
      onChange?.(arr)
    }
  }

  // 删除文件
  function onClickDel(index: string) {
    const arr = dataSource.filter((item) => item.url !== index)
    onChange?.(arr)
  }

  // 下载文件
  function onClickDown(index: number) {
    // 获取下载路径
    const file = dataSource[index]
    const url = `${file.baseUrl ? file.baseUrl : HTTP}${file.url}`
    download(url)
  }

  const uploadFlag = useRef<number>(0)

  // 上传之前处理文件
  function beforeUpload(file: RcFile, FileList: RcFile[]) {
    const reg = generateRegExp(accept)
    const index = file.name.search(reg)
    if (FileList.length + dataSource.length > maxCount) {
      message.error(`上传失败：文件数量超出限制（${maxCount}个）`)
      uploadFlag.current = 0
      return false
    }
    if (file.size > maxSize) {
      message.error(
        maxSizeErrorText ||
          `上传失败：请勿上传超过${bytesInstance.convert(maxSize)}的文件！`,
      )
      uploadFlag.current = 0
      return false
    } else if (index === -1) {
      // 限制上传文件格式
      message.error('上传失败：请上传正确的文件格式！')
      uploadFlag.current = 0
      return false
    }
    uploadFlag.current++
    if (uploadFlag.current === FileList.length) {
      uploadfile(FileList)
      uploadFlag.current = 0
    }
    return false
  }

  return (
    <div className={Style.filebox}>
      {dataSource.map((item, index) => (
        <div className={Style.fileitem} key={index}>
          <CustomIcon type="icon-wenjian1" style={{ fontSize: '20px' }} />
          <span
            onClick={() => showPreviewModal(item)}
            style={{ cursor: 'pointer' }}
          >
            {item.name}
          </span>
          <CustomIcon
            type="icon-shanchu1"
            onClick={() => onClickDel(item.url)}
            className={Style.delicon}
          />
          <Button
            size="small"
            type="link"
            style={{ fontSize: '12px' }}
            onClick={() => onClickDown(index)}
          >
            下载
          </Button>
        </div>
      ))}
      {dataSource.length < maxCount && (
        <Customupload
          accept={accept}
          uploadBtn={
            uploadBtn ?? (
              <>
                <Button
                  type="default"
                  size="small"
                  style={{ margin: '0 0 10px 0' }}
                >
                  <UploadOutlined /> {textBtn ?? '上传文件'}
                </Button>
                {uploadBtnSuffix}
              </>
            )
          }
          beforeUpload={beforeUpload}
          visibleFile={visibleFile}
          multiple={multiple}
        />
      )}
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      />
    </div>
  )
}

export default Uploadfiles
